import { atom } from 'nanostores';
import { openCopilotOverlay } from './copilotOverlay';

/** Valid tab IDs for the copilot panel. */
export type CopilotTabId = 'copilot' | 'notepad';

export function isCopilotTabId(tabId: string): tabId is CopilotTabId {
  return tabId === 'copilot' || tabId === 'notepad';
}

/** Whether the copilot panel is collapsed */
export const $copilotCollapsed = atom(false);

export function collapseCopilotPanel() {
  $copilotCollapsed.set(true);
}

export function expandCopilotPanel() {
  $copilotCollapsed.set(false);
}

export function toggleCopilotPanel() {
  $copilotCollapsed.set(!$copilotCollapsed.get());
}

/** Single source of truth for the active copilot tab. */
export const $copilotActiveTab = atom<CopilotTabId>('copilot');

export function setCopilotActiveTab(tabId: CopilotTabId): void {
  $copilotActiveTab.set(tabId);
}

/** One-shot navigation request to scroll to a specific follow-up in the follow-ups overlay. */
export const $followUpFocusTarget = atom<string | null>(null);

export function clearFollowUpFocusTarget(): void {
  $followUpFocusTarget.set(null);
}

export function focusFollowUpInTab(followUpId: string): void {
  $followUpFocusTarget.set(followUpId);
  // follow-ups now render in an overlay rather than a dedicated tab
  openCopilotOverlay('followUps');
}
